export const enum SnapshotNodeType {
  Folder = 0,
  File = 1,
  Symlink = 2,
}
